const findPercentile = ({ data, score, isRank = false }) => {
  for (let index = 0; index < data.length; index++) {
    const item = data[index];
    if (index === 0) {
      // First Element operations
      if (score >= item.score) {
        return {
          title: null,
          data: `${!isRank ? `${item.percentile}` : item.percentile}`,
        };
      } else if (score === item.score) {
        return {
          title: "between",
          data: `${data[index + 1].percentile} and ${item.percentile}`,
        };
      }
    } else if (index === data.length - 1) {
      // Last Element operations
      if (score < item.score) {
        return {
          title: null,
          data: null,
        };
      } else if (score === item.score) {
        return {
          title: null,
          data: `${item.percentile}`,
        };
      } else {
        return {
          title: "between",
          data: `${item.percentile} and ${data[index - 1].percentile}`,
        };
      }
    } else {
      // Middle Element operations
      if (score > data[index].score && score < data[index - 1].score) {
        return {
          title: "between",
          data: `${data[index].percentile} and ${data[index - 1].percentile}`,
        };
      } else if (score === item.score) {
        return {
          title: null,
          data: `${data[index].percentile}`,
        };
      }
    }
  }
  return {
    title: null,
    data: null,
  };
};

const findRank = ({ data, percentage }) => {
  const rank = data.find((item) => percentage >= item.score);
  if (!rank) {
    return {
      data: null,
      title: null,
    };
  }
  return {
    data: rank.percentile,
    title: "You are in the top",
  };
};

export { findPercentile, findRank };
